import {
    assoc,
    chain,
    concat,
    contains,
    compose,
    clone,
    differenceWith,
    eqBy,
    find,
    filter,
    flip,
    forEach,
    is,
    map,
    pick,
    prop,
    propEq,
    uniqBy
} from 'ramda';

import { getVersion } from 'utils/version';

const isNotHidden = currentVersion => field => !field.version || contains(currentVersion, field.version);
const filterVersionFields = (fields, currentVersion) => filter(isNotHidden(currentVersion), fields);

const addNonexistentFields = defaults => chain(
    flip(concat),
    compose(
        map(assoc('value', false)),
        differenceWith(eqBy(prop('name')), defaults)
    )
);

export const filterDefaultSettings = (settings) => {
    var defaults = clone(settings);
    defaults.fields = filterVersionFields(defaults.fields, getVersion());
    return defaults;
};

export const mergeSettings = (settings, stored = {}) => {
    var defaults = filterDefaultSettings(settings);

    if (stored) {
        defaults.locked = stored.locked || '';
        defaults.stringHeight = stored.stringHeight || 'nolimit';

        if (is(Array, stored.fields)) {
            let indexes = {};
            let fields = [];
            const allSorted = addNonexistentFields(defaults.fields)(stored.fields);

            forEach(field => {
                let item = find(propEq('name', field.name), defaults.fields);
                if (item && !indexes[field.name]) {
                    item.value = field.value;
                    item.width = field.width;
                    fields.push(item);
                    indexes[field.name] = true;
                }
            }, allSorted);

            defaults.fields = uniqBy(eqBy(prop('name')), fields);
        }
    }

    return defaults;
};

const getColumns = compose(
    map(pick(['name', 'width', 'keyName', 'keySort'])),
    filter(propEq('value', true))
);

export const getTableColumns = (defaultColumns, fields) => {
    return fields && concat(defaultColumns, getColumns(fields));
};
